var _g, _g2, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 135,
    viewBox: "0 0 134 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_2952_23512)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.1094,
    cy: 67.5,
    r: 52.8047,
    fill: "#FFEDD8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.1094,
    cy: 67.5,
    r: 52.8047,
    stroke: "#FFB900",
    strokeWidth: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_2952_23512)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.1094,
    cy: 67.5,
    r: 52.8047,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.1094,
    cy: 67.5,
    r: 52.8047,
    stroke: "#FFB900",
    strokeWidth: 4
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66.8211,
    cy: 56.8914,
    r: 10.2235,
    fill: "#FF8800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4531 84.4084V85.2539C43.4531 86.945 46.5278 88.3286 46.5278 88.3286C46.5278 88.3286 56.6552 95.296 66.821 95.296C76.9868 95.296 87.1911 88.3286 87.1911 88.3286C87.1911 88.3286 90.2658 86.945 90.2658 85.2539V84.4084C86.038 75.7991 77.1213 69.7266 66.821 69.7266C56.5207 69.7266 47.604 75.6454 43.4531 84.4084Z",
    fill: "#FF8800"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_2952_23512",
    x: -17.6953,
    y: -17.3047,
    width: 169.609,
    height: 169.609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2952_23512"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.160784 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2952_23512",
    result: "effect2_dropShadow_2952_23512"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2952_23512",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_2952_23512",
    x: -17.6953,
    y: -17.3047,
    width: 169.609,
    height: 169.609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2952_23512"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_2952_23512"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.666667 0 0 0 0 0.196078 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2952_23512",
    result: "effect2_dropShadow_2952_23512"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2952_23512",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPhoto);
export default __webpack_public_path__ + "static/media/UploadPhoto.04de8597f081d4c2bf326969a3687b89.svg";
export { ForwardRef as ReactComponent };